<template>
  <v-app>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card>
            <v-card-text>
              <h1 class="text-center">Sitio no encontrado</h1>
              <p class="text-center display-4">404</p>
              <v-row justify="center">
                <v-btn class="primary" @click="$router.go(-1)">
                  <v-icon left>fas fa-arrow-left</v-icon>
                  Regresar
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {}
</script>
